<script>
import Cloner from "@/libraries/Cloner";
import ContractDetailService from "@/services/ContractDetailService";

export default {
    props: {
        context: {},
        contractDetailId: {}
    },
    data() {
        return {
            loading: true,
            errors: {},
            saving: false,
            entity: {
                id: null,
                override_invoice_line: null
            }
        };
    },
    async created() {
        this.entity = Cloner.pickClone(this.context, [
            "id",
            "override_invoice_line"
        ]);

        this.loading = false;
    },
    methods: {
        async saveForm() {
            try {
                await ContractDetailService.PUT_editInvoiceNote(this.entity);

                this.$emit("close-reload");
            } catch (e) {
                this.errors = e.response.data.errors;
                console.log("save e ", e);
            }
        }
    }
};
</script>

<template>
    <modal
        size=""
        :show="true"
        @close="$emit('close')"
        class="budget-modal"
        :loading="loading"
    >
        <template slot="header">
            {{ $t("cd.modal_add_edit_contract_detail_note_for_invoice") }}
        </template>

        <template slot="default">
            <FormulateForm v-model="entity" @submit="saveForm" :errors="errors">
                <div class="row">
                    <div class="col-12">
                        <FormulateInput
                            name="override_invoice_line"
                            type="textarea"
                            :placeholder="$t('cd.invoice_text')"
                            :label="$t('cd.invoice_text')"
                            :help="$t('cd.invoice_text_help')"
                            rows="8"
                        />
                    </div>
                </div>
                <div class="row mt-4">
                    <div class="col text-right">
                        <base-button
                            type="secondary"
                            :outline="true"
                            @click="$emit('close')"
                            >{{ $t("cancel") }}</base-button
                        >
                        <base-button
                            type="primary"
                            :loading="saving"
                            native-type="submit"
                            >{{ $t("save") }}</base-button
                        >
                    </div>
                </div>
            </FormulateForm>
        </template>
    </modal>
</template>
